import { Dropdown } from "react-bootstrap";
import styles from "./vehiclecard.module.css";
import { Edit, MoreVertical, Send, Trash2 } from "react-feather";
import { useHistory } from "react-router-dom";
import { Popover } from "@mui/material";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ApprovalBadge from "../../ApprovalBadge";
// import PassCell from "../../PassCell";
import { canSendUnlockLink, isRejectedRequest, isVehicleRow, rowPhotos, rowThumb } from "../../vehicleRows";
import ListThumb from "../../ListThumb";

// Grid card; clicking it opens the vehicle details dialog (actions.openDetails)
const VehicleCard = ({ item, actions, setTenantModalOpen, setTenantDetails }) => {
  const redirect = useHistory();
  const { user, isAuthenticated } = useAuth0();
  const permissions = (isAuthenticated && user?.["https://propertydek.com/permissions"]) || [];
  const canUpdate = permissions.indexOf("vehicle:update") > -1;
  const [anchorEl, setAnchorEl] = useState(null);

  const isGuest = parseInt(item?.is_guest) === 1;
  const isVehicle = isVehicleRow(item);
  const isRejected = isRejectedRequest(item);
  const thumb = rowThumb(item);
  const fullImage = rowPhotos(item)[0]?.url || thumb;
  // const showMenu = canUpdate && (isVehicle || !isGuest || isRejected);
  const showMenu = canUpdate && (isVehicle || isRejected);

  const goToTenantetails = (row) => {
    if (permissions.indexOf("tenant-contactinfo:read") > -1 && permissions.indexOf("tenant-journey:read") > -1) {
      redirect.push("/people/tenants/details/" + row.tenant_id);
    } else {
      setTenantModalOpen(true);
      setTenantDetails(row?.tenant_details);
    }
  }

  return (<>
    <div className={`${styles.ProspectCard}`}>
      <div className={`${styles.ProspectCardUnder}`} style={{ cursor: "pointer" }} onClick={() => actions?.openDetails(item)}>
        <div className={`${styles.ProspectCardHeadSection}`}>
          <div className={`${styles.LeaseIMGSec}`}>
            {thumb ? (<span onMouseEnter={(e) => setAnchorEl(e.currentTarget)} onMouseLeave={() => setAnchorEl(null)} style={{ width: "100%", height: "100%" }}>
              <ListThumb thumb={thumb} full={fullImage} className={`${styles.CarUploadImage}`} />
            </span>) : (<img src="/static/img/car.svg" alt="" />)}
          </div>

          <div className={`${styles.HeadConSec}`}>
            <div className={`${styles.prospectNameActionSec}`}>
              {/* Guest name: plain text. Tenant name: clickable link */}
              {isGuest ? (
                <p className={`${styles.ProsUserName} ${styles.Guest}`}>{item?.name}</p>
              ) : (
                <p className={`${styles.ProsUserName} ${styles.CallLink}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); goToTenantetails(item); }}>{item?.name}</p>
              )}

              {showMenu && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id={`vehicle-card-actions-${item.key}`}>
                  <MoreVertical />
                </Dropdown.Toggle>
                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                  {(isVehicle || isRejected) && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => (isRejected ? actions?.openEditRequest(item) : actions?.openEdit(item))}>
                    <Edit /> Edit
                  </Dropdown.Item>}
                  {/* Send update link is no longer used
                  {!isGuest && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => actions?.openSendLink(item)}>
                    <Send /> Send update link
                  </Dropdown.Item>} */}
                  {canSendUnlockLink(item) && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={() => actions?.sendAccessLink(item)}>
                    <Send /> Send unlock link (SMS)
                  </Dropdown.Item>}
                  {(isVehicle || (isRejected && actions?.canDelete)) && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={() => (isRejected ? actions?.openDeleteRequest(item) : actions?.openDelete(item))}>
                    <Trash2 /> Delete
                  </Dropdown.Item>}
                </Dropdown.Menu>
              </Dropdown>}
            </div>
            <div className={`${styles.prospectNameActionSec}`} style={{ marginBottom: '6px' }}>
              <p className={`${styles.ProsUserName}`}>{item?.license}</p>

              {item?.isNew && <span className={`${styles.PublishBadge}`} style={{ marginLeft: 'auto' }}>New</span>}
              {isGuest && <span className={`${styles.PublishBadge} ${styles.Guest}`}>Guest</span>}
            </div>
          </div>
        </div>

        <div className={`${styles.ProspectCardBodySec}`}>
          <ul>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/make.svg" alt="" />Make :</p>
              <p className={`${styles.Content}`}>{item?.make}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/model.svg" alt="" />Model :</p>
              <p className={`${styles.Content}`}>{item?.model}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/color.svg" alt="" />Color :</p>
              <p className={`${styles.Content}`}>{item?.color}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/home.svg" alt="" />Property :</p>
              <p className={`${styles.Content} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (item?.property_id) redirect.push("/properties/details/" + item.property_id); }}>{item?.property}</p>
            </li>
            <li>
              <p className={`${styles.Title}`}><img src="/static/img/rooms.svg" alt="" />Unit :</p>
              <p className={`${styles.Content}`}>{item?.unit}</p>
            </li>
          </ul>
        </div>
        <div className={`${styles.TemplateCardFoot} ${styles.CardApprovalFoot}`}>
          <ApprovalBadge row={item} showSub={false} />
          {/* Parking pass: payments / passes are no longer used for guest access
          <div className={`${styles.CardPassSec}`}>
            <PassCell row={item} showSub={false} />
          </div> */}
        </div>
      </div>
    </div>

    <Popover
      id="mouse-over-popover"
      sx={{ pointerEvents: "none" }}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      onClose={() => setAnchorEl(null)}
      disableRestoreFocus
    >
      <div className={`${styles.PopupImgSec}`}>
        <img src={fullImage} alt="" />
      </div>
    </Popover>
  </>);
};

export default VehicleCard;
